import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import R from "ramda";
import renderHTML from "react-render-html";
import { Grid, Button, Container, Typography } from "@material-ui/core";
import PropTypes from "prop-types";

import HolidayPresenter from "presenters/HolidayPresenter";
import { appRoutes } from "routes";
import { holidays, nonHolidays } from "utils/holidaysUtils";

import useStyles from "./useStyles";

const Categories = ({ isDescriptionVisible }) => {
  const classes = useStyles();

  const sortedHolidays = R.sortBy(HolidayPresenter.diffInDaysAbsolute)(holidays);
  const holidaysColumns = R.pipe(R.splitEvery(2), R.transpose)(sortedHolidays);

  const celebrate = ["Birthdays", "Anniversary", "Weddings", "Graduation", "Baby"];
  const celebrateColumn = nonHolidays.filter(({ name }) => celebrate.includes(name));

  const greetings = ["Love", "Thanks", "You Rock", "Get well", "Congrats", "Sorry"];
  const greetingsColumn = nonHolidays.filter(({ name }) => greetings.includes(name));

  const renderCategory = (category) => (
    <Link
      key={HolidayPresenter.name(category)}
      className={classes.link}
      to={appRoutes.categoryPath(HolidayPresenter.slug(category))}
    >
      {renderHTML(HolidayPresenter.title(category))}
    </Link>
  );

  return (
    <div className={classes.root}>
      <Container>
        {isDescriptionVisible && (
          <div>
            <Typography variant="h2" className={classes.title}>
              Send Funny Ecards – All Year Long!
            </Typography>
            <Typography component="p" className={classes.description}>
              There’s always an occasion to cheer someone up - using our funny, personalized videos with JibJab style
              and humor. We provide 100s of Ecards and year-round fun for the whole family, your friends & co-workers.
              So get your smile on, and stick your face in it!
            </Typography>
          </div>
        )}

        <Grid container className={classes.grid}>
          <Grid item xs={12} sm={6}>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="h3" className={clsx(classes.groupTitle, classes.groupTitleHolidays)}>
                  Holidays
                </Typography>
              </Grid>
              {holidaysColumns.map((column, index) => (
                <Grid key={index} item xs={6}>
                  {column.map(renderCategory)}
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="h3" className={clsx(classes.groupTitle, classes.groupTitleCelebrate)}>
                  Celebrate
                </Typography>
                {celebrateColumn.map(renderCategory)}
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h3" className={clsx(classes.groupTitle, classes.groupTitleGreetings)}>
                  Greetings
                </Typography>
                {greetingsColumn.map(renderCategory)}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container direction="row" justify="center" alignItems="center">
          <Grid item>
            <Button component={Link} variant="outlined" color="primary" size="large" to={appRoutes.categoriesPath()}>
              Browse All Categories
            </Button>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

Categories.propTypes = {
  isDescriptionVisible: PropTypes.bool,
};

Categories.defaultProps = {
  isDescriptionVisible: true,
};

export default Categories;
